import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import { listStado } from '../../../interfaces/project/stages/create/listStado';
import { listStage } from '../../../interfaces/project/stages/create/listStage';
import { listProjectStage } from '../../../interfaces/project/stages/create/listProjectStage';
import { createProjectStage } from '../../../interfaces/project/stages/create/createProjectStage';
import { FormBuilder, FormGroup } from '@angular/forms';
import { infoProjectStage } from '../../../interfaces/project/stages/infoProjectStage';
import { updateProjectStage } from '../../../interfaces/project/stages/updateProjectStage';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'app-project-stages-create',
  templateUrl: './project-stages-create.component.html',
  styleUrls: ['./project-stages-create.component.scss'],
})
export class ProjectStagesCreateComponent
  implements AfterViewInit, OnDestroy, OnInit
{
  idProject: number;
  idStage: number;

  createProjectStage: createProjectStage;
  updateProjectStage: updateProjectStage;
  listStado: listStado[] = [];
  listStage: listStage[] = [];
  listProjectStage: listProjectStage[] = [];
  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto;
  private apiService: ApiServiceProject;
  createProjectStageForm: FormGroup;
  infoProjectStage: infoProjectStage;
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private fb: FormBuilder,
    private errorService:ErrorService
  ) {
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.idStage = params['idStage'];
    });

    if (isNaN(this.idStage)) {
      this.titleService.setTitle('PDG - Crear etapa de proyecto');
    } else {
      this.titleService.setTitle('PDG - Editar etapa de proyecto');
    }
  }

  ngOnInit(): void {
    this.createProjectStageForm = this.fb.group({
      stagesId:[''],
      state: [''],
      startDate: [''],
      endDate: [''],
      dependenceId: [''],
    });
    this.apiService = new ApiServiceProject(this.http);
    this.spinner.show();
    this.apiService
      .getService('project-view-stage-create-info?id_project=' + this.idProject)
      .subscribe({
        next: (rs: any) => {

          if (rs.code == null) {
            // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
            if (rs == '' || rs == null) {
              this.spinner.hide();
              Swal.fire({
                title: 'No se encontraron registros',
                text: '',
                icon: 'info',
                confirmButtonText: 'Aceptar',
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed || res.isDismissed) {
                  this.router.navigate(['home']);
                }
              });
            }

            this.listStado = rs.listStado;

            this.listStage = rs.listStage;

            this.listProjectStage = rs.listProjectStage;

            this.infoEdit();

            this.spinner.hide();
            this.rerender();
          } else {
            this.spinner.hide();
            Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
          }
        },
        error: (error) => {
          this.errorService.error(error);
        },
      });
    // this.apiService
    //   .getService('project-info?id_project=' + this.idProject)
    //   .subscribe({
    //     next: (rs: any) => {
    //       if (rs.code == null) {
    //         this.summaryInfoDto = rs;

    //         this.spinner.hide();
    //       } else {
    //         this.spinner.hide();
    //         Swal.fire({
    //         title:  rs.error,
    //         text: '',
    //         icon: 'error',
    //         heightAuto: false
    //         });
    //       }
    //     },
    //     error: (error) => {
    //       this.errorService.error(error);
    //     },
    //   });
   
  }

  infoEdit(){
    this.summaryInfoDto.title = localStorage.getItem("title");
   
     if (!isNaN(this.idStage)) {
      this.apiService
        .getService('info-project-stage?id=' + this.idStage)

        .subscribe({
          next: (rs: any) => {
            if (rs.code == null) {

              this.createProjectStageForm.patchValue({
                stagesId: rs.infoStages.stages_id,
                state: rs.infoStages.state,
                startDate:  moment(rs.infoStages.realStartDate, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
                endDate:  moment(rs.infoStages.realEndDate, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
                dependenceId:
                rs.infoStages.dependence_id == 0
                    ? ''
                    : rs.infoStages.dependence_id,
              });
              this.createProjectStageForm.controls['stagesId'].disable();
              this.spinner.hide();
            } else {
              this.spinner.hide();
              Swal.fire({
              title:  rs.error,
              text: '',
              icon: 'error',
              heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
    }

  }

  formSubmit(): void {
    this.spinner.show();
    if (this.createProjectStageForm.value.stageId === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una etapa' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createProjectStageForm.value.state === '') {
      this.spinner.hide();
     Swal.fire({title:'Debe seleccionar un estado' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createProjectStageForm.value.startDate === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha de inicio' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createProjectStageForm.value.endDate === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha de fin' ,text: '',icon: 'error',heightAuto: false});
      return;
    }


    if (isNaN(this.idStage)) {
      
      this.createProjectStage = new createProjectStage();

      this.createProjectStage.startDate = moment(this.createProjectStageForm.value.startDate).format("DD-MM-YYYY");
      this.createProjectStage.endDate = moment(this.createProjectStageForm.value.endDate).format("DD-MM-YYYY");

      this.createProjectStage.dependenceId = Number(this.createProjectStageForm.value.dependenceId)
      this.createProjectStage.stagesId = Number(this.createProjectStageForm.value.stagesId)
      this.createProjectStage.state = Number(this.createProjectStageForm.value.state)
      this.createProjectStage.projectsId = Number(this.idProject)


      this.apiService
        .postService('project-view-stage-create', this.createProjectStage)
        .subscribe({
          next: (rs: any) => {
            if(rs.message){
              this.spinner.hide();
              Swal.fire({title:rs.message ,text: '',icon: 'success',heightAuto: false});
              this.router.navigate(['/pdg/project', this.idProject, 'stages']);
            }
            else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
    } else {

      this.updateProjectStage = new updateProjectStage();

      this.updateProjectStage.id = Number(this.idStage);
      this.updateProjectStage.state = Number(this.createProjectStageForm.value.state);
      this.updateProjectStage.dependenceId = Number(this.createProjectStageForm.value.dependenceId)
      this.updateProjectStage.startDate = moment(this.createProjectStageForm.value.startDate).format("DD-MM-YYYY");
      this.updateProjectStage.endDate = moment(this.createProjectStageForm.value.endDate).format("DD-MM-YYYY");

      this.apiService
        .postService('project-view-stage-update', this.updateProjectStage)
        .subscribe({
          next: (rs: any) => {
            if (rs.code == null) {
              this.spinner.hide();
              Swal.fire({title:'Se actualizo correctamente' ,text: '',icon: 'success',heightAuto: false});
              this.router.navigate(['/pdg/project', this.idProject, 'stages']);
            } else {
              this.spinner.hide();
              Swal.fire({
              title:  rs.error,
              text: '',
              icon: 'error',
              heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
    }
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  rerender(): void {}
}
